// @flow

import { type State } from './reducers';

type GlobalState = {
  formidableSettings: State,
};

const getReducer = (state: GlobalState): State => {
  const { formidableSettings } = state;
  if (!formidableSettings) {
    throw new Error('Missing formidableSettings store.');
  }
  return formidableSettings;
};

type FormSubmitFailedErrorText = $PropertyType<State, 'form_submit_failed_error_text'>;
export const getFormSubmitFailedErrorText = (state: GlobalState): FormSubmitFailedErrorText => (
  getReducer(state).form_submit_failed_error_text
);

export default getReducer;
